// import React from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";
// import logo from "../../img/aarcon_logo.png"; // make sure this path is correct

// function Navbar() {
//   return (
//     <nav className="navbar">
//       {/* Logo */}
//       <div className="navbar-logo">
//         <Link to="/">
//           <img src={logo} alt="Aarcon Construction Logo" />
//         </Link>
//       </div>

//       {/* Links */}
//       <ul className="navbar-links">
//         <li>
//           <Link to="/">Home</Link>
//         </li>
//         <li>
//           <Link to="/projects">Projects</Link>
//         </li>
//         <li>
//           <Link to="/services">Services</Link>
//         </li>
//         <li>
//           <Link to="/about">About Us</Link>
//         </li>
//         <li>
//           <Link to="/contact">Contact</Link>
//         </li>
//       </ul>

//       {/* CTA Button */}
//       <Link to="/contact">
//         <button className="navbar-btn">Get Quote</button>
//       </Link>
//     </nav>
//   );
// }

// export default Navbar;


import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi"; // hamburger & close icons
import "./navbar.css";
import logo from "../../img/aarrcon_logo1.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Aarcon Construction Logo" />
        </Link>
      </div>

      {/* Menu Icon (only visible on mobile) */}
      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
      </div>

      {/* Links */}
      <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={closeMenu}>Home</Link>
        </li>
        <li>
          <Link to="/projects" onClick={closeMenu}>Projects</Link>
        </li>
        <li>
          <Link to="/services" onClick={closeMenu}>Services</Link>
        </li>
        <li>
          <Link to="/about" onClick={closeMenu}>About Us</Link>
        </li>
        <li>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
        </li>
        <li className="mobile-btn">
          <Link to="/contact" onClick={closeMenu}>
            <button className="navbar-btn">Get Quote</button>
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
